export default __webpack_public_path__ + "static/media/NegocioIMG.3c8463d1.png";